var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const initNavigationBar = /* @__PURE__ */ __name(($el, $refs) => {
  const routerStore = window.Alpine.store("router");
  const modalStore = window.Alpine.store("modal");
  const toggleTransparent = /* @__PURE__ */ __name((e, instant = false) => {
    const handleTransition = /* @__PURE__ */ __name(() => {
      var _a, _b, _c, _d;
      const { transparentTemplates } = $el.dataset;
      utils.calculateHeaderHeight();
      const templates = transparentTemplates.split(",").map(
        (t) => {
          var _a2, _b2;
          return (_b2 = (_a2 = t.trim()) == null ? void 0 : _a2.split(".")) == null ? void 0 : _b2.filter((t2) => t2);
        }
      );
      const transparent = templates == null ? void 0 : templates.some(
        ([prefix, suffix]) => {
          var _a2, _b2, _c2, _d2, _e, _f;
          return ((_c2 = (_b2 = (_a2 = _stores.router) == null ? void 0 : _a2.template) == null ? void 0 : _b2.split(".")) == null ? void 0 : _c2[0]) === prefix && (!suffix || ((_f = (_e = (_d2 = _stores.router) == null ? void 0 : _d2.template) == null ? void 0 : _e.split(".")) == null ? void 0 : _f[1]) === suffix);
        }
      );
      document.body.style.setProperty("--navigation-bar-transparent-height", transparent ? `-${$el.clientHeight}px` : `0`);
      if (transparent || !transparent && ((_a = $el == null ? void 0 : $el.classList) == null ? void 0 : _a.contains("navigation-bar--transparent"))) {
        const makeTransparent = transparent && !_stores.modal.id.includes("megamenu-") && _stores.modal.id !== "search" && !_stores.modal.id.includes("country-selector") && window.scrollY <= 300 && (e == null ? void 0 : e.type) !== "pointerover";
        (_b = $el == null ? void 0 : $el.classList) == null ? void 0 : _b.toggle("navigation-bar--transparent", makeTransparent);
        (_d = (_c = $refs == null ? void 0 : $refs.navigation_bar_background_image) == null ? void 0 : _c.classList) == null ? void 0 : _d.toggle("!opacity-0", makeTransparent);
      }
    }, "handleTransition");
    if (instant) {
      handleTransition();
    } else {
      Alpine.nextTick(handleTransition);
    }
  }, "toggleTransparent");
  toggleTransparent();
  Alpine.effect(() => {
    if ((modalStore == null ? void 0 : modalStore.id) || !(modalStore == null ? void 0 : modalStore.id)) {
      toggleTransparent();
    }
  });
  const showConditionally = /* @__PURE__ */ __name((element, settings) => {
    var _a, _b;
    const {
      hide_if_empty,
      hide_if_set_paths,
      required_paths,
      hide_if_set_templates,
      required_templates,
      match_paths,
      match_templates
    } = settings;
    const paths = match_paths == null ? void 0 : match_paths.split(",").map((path) => path.trim());
    const templates = match_templates == null ? void 0 : match_templates.split(",").map((path) => path.trim());
    let hide = false;
    if (paths == null ? void 0 : paths.length) {
      if (hide_if_set_paths && paths.includes(routerStore.pathname)) {
        hide = true;
      }
      if (required_paths && !paths.includes(routerStore.pathname)) {
        hide = true;
      }
    }
    if (templates == null ? void 0 : templates.length) {
      if (hide_if_set_templates && (templates.includes(routerStore.template) || templates.includes(routerStore.template.split(".")[0]))) {
        hide = true;
      }
      if (required_templates && !(templates.includes(routerStore.template) || templates.includes(routerStore.template.split(".")[0]))) {
        hide = true;
      }
    }
    switch (hide_if_empty) {
      case "none":
        break;
      case "section":
        (_a = element.closest(`.shopify-section`)) == null ? void 0 : _a.classList.toggle("!hidden", hide);
        break;
      case "container":
        (_b = element.closest(`[data-style-id]:not([data-style-id="${element.getAttribute("data-style-id")}"])`)) == null ? void 0 : _b.classList.toggle("!hidden", hide);
        break;
      case "block":
        element == null ? void 0 : element.classList.toggle("!hidden", hide);
        break;
    }
  }, "showConditionally");
  return {
    $el,
    $refs,
    showConditionally,
    toggleTransparent
  };
}, "initNavigationBar");
window._sections["initNavigationBar"] = initNavigationBar;
